import { useQuery } from "@tanstack/react-query";
import { activitySidebarService } from "../../services/activitySidebar.service";

const POLL_INTERVAL_MS = 30_000;

// SIMS-4178: the "Delayed & Missed" activity list for the sidebar.
export const useDelayedMissed = (coordinatorId: string | undefined) => {
	return useQuery({
		queryKey: ["sims-activity-delayed-missed", coordinatorId],
		queryFn: () =>
			activitySidebarService.getDelayedMissed(coordinatorId as string),
		enabled: Boolean(coordinatorId),
		staleTime: 15_000,
		gcTime: 300_000,
		refetchInterval: POLL_INTERVAL_MS,
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
	});
};
